
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members-power-deals",
      function () {
        return require("private-next-pages/members-power-deals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members-power-deals"])
      });
    }
  